import { combineReducers } from '@reduxjs/toolkit';
import {AppReducer} from './app/app'
import {RoomReducer} from './cart/cart';
import {PaymentReducer} from './payment/payment'
import {NotifierReducer} from './notifier/notifier'
export const rootReducer = combineReducers({
    app:AppReducer,
    room:RoomReducer,
    payment:PaymentReducer,
    notifier:NotifierReducer,
})

export type RootState = ReturnType<any>

export default rootReducer
